"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sala-biellese": {
    "eda2d41f": [{
      "hkey": "188198f9",
      "slug": "sala-biellese",
      "name": "Sala Biellese",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "188198f9",
      "slug": "sala-biellese",
      "name": "Sala Biellese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92f10ae0": [{
      "hkey": "188198f9",
      "slug": "sala-biellese",
      "name": "Sala Biellese",
      "primary": true,
      "skipSearch": false
    }],
    "mombello": [{
      "hkey": "188198f9",
      "slug": "sala-biellese",
      "name": "Sala Biellese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f18d86df": [{
      "hkey": "188198f9",
      "slug": "sala-biellese",
      "name": "Sala Biellese",
      "primary": true,
      "skipSearch": false
    }],
    "san-grato": [{
      "hkey": "188198f9",
      "slug": "sala-biellese",
      "name": "Sala Biellese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;